import analytics from "./analytics";

const trackAnalytics = (eventName, anotherProps) => {
    const userId = localStorage.getItem("userId");
    const userRole = localStorage.getItem("userRoles");
    const userEmail = localStorage.getItem("email");

    analytics.track(eventName, {
        userId,
        userRole,
        userEmail,
        ...anotherProps,
    });
};

export default trackAnalytics;
